import { FormGroup } from '@angular/forms';

export class MatchPasswordValidator {
  static validate(registrationFormGroup: FormGroup) {
    const password = registrationFormGroup.controls['newPassword'].value;
    const repeatPassword = registrationFormGroup.controls['newPasswordconf'].value;
    if (repeatPassword !== password) {
      return {
        doesMatchPassword: true
      };
    }
    return null;
  }
}
